import React from "react";

interface UrlGisHierarchyContextType {
    url: string,
    showPanel: boolean,
    gisItems: any[]
}

const UrlGisHierarchyContext = React.createContext<UrlGisHierarchyContextType>({
    url: "",
    showPanel: false,
    gisItems: []
});

export default UrlGisHierarchyContext;